import { useEffect, useState } from 'react';

const navItems = [
  { id: 'top', label: '首页' },
  { id: 'hot', label: '吃瓜热点' },
  { id: 'onsite', label: '现场爆料' },
  { id: 'ticker', label: '新料速递' },
  { id: 'guide', label: '吃瓜指南' },
  { id: 'faq', label: '常见疑问' },
];

export default function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const [searchOpen, setSearchOpen] = useState(false);
  const [keyword, setKeyword] = useState('');
  const [hint, setHint] = useState('');

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const handleSearch = () => {
    const value = keyword.trim();
    setHint(value ? `已记录关键词「${value}」，演示页暂不联网检索` : '输入关键词试试看');
  };

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-colors duration-300 ${
        scrolled || menuOpen ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-8">
        <div className="flex h-16 md:h-20 items-center justify-between gap-4">
          <a href="#top" className="flex items-center gap-3 cursor-pointer">
            <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-primary-500 text-background-50">
              <i className="ri-alarm-warning-line text-xl" />
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`font-heading text-lg md:text-xl font-bold tracking-wide ${
                  scrolled || menuOpen ? 'text-foreground-950' : 'text-background-50'
                }`}
              >
                黑料51
              </span>
              <span className="mt-1 text-[10px] md:text-xs font-label tracking-[0.25em] text-accent-400">
                CHIGUA FEED
              </span>
            </span>
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className={`whitespace-nowrap rounded-md px-3 py-2 text-sm font-label transition-colors cursor-pointer ${
                  scrolled
                    ? 'text-foreground-700 hover:bg-background-200 hover:text-foreground-950'
                    : 'text-background-100/90 hover:bg-white/15 hover:text-background-50'
                }`}
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <div className="hidden md:flex items-center">
              {searchOpen && (
                <input
                  type="text"
                  value={keyword}
                  onChange={(event) => setKeyword(event.target.value)}
                  onKeyDown={(event) => {
                    if (event.key === 'Enter') handleSearch();
                  }}
                  placeholder="搜索瓜料关键词"
                  className="mr-2 w-44 rounded-md border border-background-300 bg-background-50 px-3 py-2 text-sm text-foreground-900 outline-none focus:border-primary-400"
                />
              )}
              <button
                type="button"
                onClick={() => {
                  if (searchOpen) handleSearch();
                  setSearchOpen(!searchOpen);
                }}
                aria-label="搜索"
                className={`flex h-10 w-10 items-center justify-center rounded-md transition-colors cursor-pointer ${
                  scrolled
                    ? 'bg-background-200 text-foreground-800 hover:bg-background-300'
                    : 'bg-white/15 text-background-50 hover:bg-white/25'
                }`}
              >
                <i className="ri-search-line text-lg" />
              </button>
            </div>
            <a
              href="#subscribe"
              className="hidden sm:inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
            >
              <i className="ri-notification-3-line" />
              关注速递
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="菜单"
              className={`flex h-10 w-10 items-center justify-center rounded-md lg:hidden cursor-pointer ${
                scrolled || menuOpen ? 'bg-background-200 text-foreground-900' : 'bg-white/15 text-background-50'
              }`}
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
            </button>
          </div>
        </div>

        {hint && (
          <p
            className={`pb-3 text-xs font-label ${
              scrolled || menuOpen ? 'text-foreground-600' : 'text-background-100'
            }`}
          >
            {hint}
          </p>
        )}
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 lg:hidden">
          <div className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                onClick={() => setMenuOpen(false)}
                className="whitespace-nowrap rounded-md bg-background-100 px-3 py-3 text-sm text-foreground-800 cursor-pointer"
              >
                {item.label}
              </a>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}